export const validateApiResponse = (response) => {
  // console.log(response, "Receiving");
  if (!response || typeof response !== "object") {
    throw new Error("Invalid API response format.");
  }

  const { status, message } = response;

  if (typeof status !== "string") {
    throw new Error("API response missing 'status' field.");
  }

  if (typeof message !== "string") {
    throw new Error("API response missing 'message' field.");
  }

  // data can be null, but must exist
  if (!("data" in response)) {
    throw new Error("API response missing 'data' field.");
  }

  return response; // validated successfully
};
